module.exports = __webpack_public_path__ + "img/leadpoet.ecaeb61c.svg";